import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom'
import './adminSideBar.css';
import { logout } from '../../context/authContext/AuthActions';
import { AuthContext } from '../../context/authContext/AuthContext';

function AdminSideBar({ activeTab }) {
    const [collapsed, setCollapsed] = useState(true);
    const [open, setOpen] = useState("");
    const [ulHeight, setUlHeight] = useState(0);
    const listDropDownNames = ['services1', 'bookmarks1', 'services2', 'bookmarks2']
    const { dispatch } = useContext(AuthContext);

    const collapsedHandler = (e) => {
        e.preventDefault();
        setCollapsed(prev => !prev);
        setOpen('');
        setUlHeight(0);
    }
    const openHandler = (e, item) => {
        if (open === item) {
            setOpen('');
            setUlHeight(0);
        } else {
            setOpen(item);
            setUlHeight(e.target.nextElementSibling.scrollHeight);
        }
    }

    return (
        <>
            {/* <!-- Mobile Sidebar Menu Button --> */}
            <button className="sidebar-menu-button" onClick={collapsedHandler}>
                <span className="material-symbols-rounded">menu</span>
            </button>

            <aside className={collapsed ? "sidebar collapsed" : "sidebar"}>
                {/* <!-- Sidebar header--> */}
                <header className="sidebar-header">
                    <a href="#" className="header-logo">
                        <img src="/logo.png" alt="CodingNepal" />
                    </a>
                    <button className="sidebar-toggler" onClick={collapsedHandler}>
                        <span className="material-symbols-rounded">chevron_left</span>
                    </button>
                </header>

                {/* <!-- Sidebar body --> */}
                <nav className="sidebar-nav">
                    {/* <!-- Primary Top Nav --> */}
                    <ul className="nav-list primary-nav">
                        <li className={activeTab === "home" ? "nav-item active" : "nav-item"}  >
                            <Link to={`/`} className="nav-link">
                                <span className="material-symbols-rounded">dashboard</span>
                                <span className="nav-label">Dashboard</span>
                            </Link>
                            <ul className="dropdown-menu">
                                <li className="nav-item"><a className="nav-link dropdown-title">Dashboard</a></li>
                            </ul>
                        </li>
                        <li className={activeTab === "envoie" ? "nav-item active" : "nav-item"} >
                            <Link to={`/envois`} className="nav-link">
                                <span className="material-symbols-rounded">package_2</span>
                                <span className="nav-label">Envois</span>
                            </Link>
                            <ul className="dropdown-menu">
                                <li className="nav-item"><a className="nav-link dropdown-title">Envois</a></li>
                            </ul>
                        </li>

                        {/* <!--   --> */}
                          <li className={activeTab === "infoperson" ? "nav-item active" : "nav-item"} >
                            <Link to={`/infoperson`} className="nav-link">
                                <span className="material-symbols-rounded">help</span>
                                <span className="nav-label">Infos Personnelles</span>
                            </Link>
                            <ul className="dropdown-menu">
                                <li className="nav-item"><a className="nav-link dropdown-title">Infos Personnelles</a></li>
                            </ul>
                        </li>
                        <li className="nav-item" onClick={() => dispatch(logout())}>
                            <a href="#" className="nav-link">
                                <span className="material-symbols-rounded">logout</span>
                                <span className="nav-label">Sign Out</span>
                            </a>
                            <ul className="dropdown-menu">
                                <li className="nav-item"><a className="nav-link dropdown-title">Sign Out</a></li>
                            </ul>
                        </li>
                    </ul>

                    {/* <!-- Secondary Bottom Nav --> */}
                    {/* <ul className="nav-list secondary-nav">
                        <li className={activeTab === "infoperson" ? "nav-item active" : "nav-item"} >
                            <Link to={`/infoperson`} className="nav-link">
                                <span className="material-symbols-rounded">help</span>
                                <span className="nav-label">Infos Personnelles</span>
                            </Link>
                            <ul className="dropdown-menu">
                                <li className="nav-item"><a className="nav-link dropdown-title">Infos Personnelles</a></li>
                            </ul>
                        </li>
                        <li className="nav-item" onClick={() => dispatch(logout())}>
                            <a href="#" className="nav-link">
                                <span className="material-symbols-rounded">logout</span>
                                <span className="nav-label">Sign Out</span>
                            </a>
                            <ul className="dropdown-menu">
                                <li className="nav-item"><a className="nav-link dropdown-title">Sign Out</a></li>
                            </ul>
                        </li>
                    </ul> */}
                </nav>
            </aside>
        </>
    )
}

export default AdminSideBar
